import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) => {
    return `${host}/itsm/${project}/get_change_request_count?${params}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    if (!json?.OTHER) return json
    const { OTHER, ...accounts } = json
    return { ...accounts, EMPTY: OTHER }
  }
}
export default createFetcher(fetcherConfiguration)
